function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import SignatureModal from './signatureModal';
import logValueOnChange from '../commonActions/logValueOnChange';
const SignatureField = ({
  enabled,
  label: _label = 'Signature',
  value: _value = {
    _download: ''
  },
  onChange,
  path,
  testingIdentifier: _testingIdentifier = null
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleChange = file => {
    if (!file) {
      onChange({
        path,
        value: null,
        displayValue: 'removed signature'
      });
      return;
    }
    const newValue = {
      _cache: file.cachedUrl,
      _download: file.fileName
    };
    const displayValue = newValue._download;
    onChange({
      path,
      value: newValue,
      displayValue
    });
  };
  const handleOpen = () => {
    if (!enabled) return;
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };
  const sigSrc = typeof _value._cache !== 'undefined' ? _value._cache : null;
  const signatureDisplayStyle = {
    width: '100%',
    height: '111px',
    maxWidth: '100%'
  };
  const signatureDisplay = sigSrc ? /*#__PURE__*/React.createElement("img", {
    alt: "signature",
    className: "t-sf-img",
    "data-testid": "t-sf-img",
    src: sigSrc,
    style: signatureDisplayStyle
  }) : /*#__PURE__*/React.createElement("div", {
    className: "t-sf-div",
    "data-testid": "t-sf-div",
    style: _objectSpread(_objectSpread({}, signatureDisplayStyle), {}, {
      display: 'block'
    })
  }, "\xA0");
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": _testingIdentifier,
    className: _testingIdentifier
  }, /*#__PURE__*/React.createElement(Label, {
    style: {
      display: 'block'
    }
  }, _label), /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: enabled ? 'pointer' : 'not-allowed'
    },
    className: "t-sf-add-signature tqc-control form-control",
    onClick: handleOpen,
    onKeyPress: handleOpen,
    role: "button",
    tabIndex: 0
  }, signatureDisplay), /*#__PURE__*/React.createElement(SignatureModal, {
    isOpen: isModalOpen,
    onHide: handleClose,
    onChange: handleChange,
    enabled: enabled
  }));
};
SignatureField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testingIdentifier: PropTypes.string,
  value: PropTypes.shape({
    _download: PropTypes.string,
    _cache: PropTypes.string
  })
};
export { SignatureField as UncomposedSignatureField };
export default entityComposition(SignatureField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});